import { FlexSpacer } from 'ui/flexSpacer/FlexSpacer';
import { Container } from 'ui/container/Container';
import { RelativeTime } from 'ui/utility/relativeTime';
import { StyledDL } from '../ContentPreview.styled';
import { marked } from 'marked';
import { useEffect } from 'react';
import { PreviewWhatsAppHeader } from './PreviewWhatsAppHeader';
import { whatsAppPreProcessor } from './utils';
import {
  ChatTick,
  MessageBody,
  MessageBodyWhatsAppMessage,
  MessageBodyWhatsAppMessageContainer,
  StyledMarkdown,
} from './ContentPreviewWhatsApp.styled';

import type { TemplateDiffContentPreviewProps, TemplateDiffContentWhatsApp } from '../../../types';

// WhatsApp message have no restore functionality. So we simply show the message without any additional actions.
type ContentPreviewWhatsAppProps = TemplateDiffContentWhatsApp &
  Omit<TemplateDiffContentPreviewProps, 'onClick'>;

export const ContentPreviewWhatsApp = ({ templateId, ...content }: ContentPreviewWhatsAppProps) => {
  useEffect(() => {
    marked.use({ hooks: { preprocess: whatsAppPreProcessor } });

    return () => {
      marked.use();
    };
  }, []);

  return (
    <Container size="medium" variant="primary" shadow="small">
      <FlexSpacer flexDirection="column" alignItems="stretch" gap="actionGap">
        <FlexSpacer justifyContent="space-between" alignItems="baseline">
          <StyledDL>
            <dt>Created</dt>
            <dd>
              <RelativeTime timestamp={content.createdAt} />
            </dd>
            <dt>Created by</dt>
            <dd>{content.creatorUserId}</dd>
          </StyledDL>
        </FlexSpacer>
        <Container size="small" hasBorder variant="tertiary">
          <MessageBody>
            <MessageBodyWhatsAppMessageContainer>
              <ChatTick />
              <MessageBodyWhatsAppMessage data-test="table-diff-whats-app-message">
                {content.header && <PreviewWhatsAppHeader header={content.header} />}
                <StyledMarkdown id="whats-app-preview-body" markdownText={content.message.trim()} />
              </MessageBodyWhatsAppMessage>
            </MessageBodyWhatsAppMessageContainer>
          </MessageBody>
        </Container>
      </FlexSpacer>
    </Container>
  );
};
